import styled from "styled-components";

export const CheckBoxForm = styled.input`
  width: 20px;
  height: 20px;  
  margin-left: 15px;
  margin-bottom: 15px;
`;